/* eslint-disable no-unused-vars */
import ApiFetch from 'utils/apiFetch';
import { CMS_POPUP_TYPE } from 'constants/cms';
import { preparePath } from 'utils/preparePath';

import { CMS_API_URL } from 'constants/apiConf';

// CMS content is shared with the native app; skip the PORTAL origin so the web
// reads the same values (WEB_MLS-779).
const ApiFetchInstance = ApiFetch(CMS_API_URL, { skipOrigin: true });

export const URLS = {
  page: 'cms/pages/url',
  popups: 'cms/popups',
  popupsByUser: 'cms/popups-by-user/:clientId/',
  documents: 'cms/documents/public',
};

export default {
  getPage(path) {
    return ApiFetchInstance.get(`${URLS.page}?url=${path}`);
  },
  getPopups() {
    return ApiFetchInstance.get(preparePath(URLS.popups, null, { type: CMS_POPUP_TYPE.IN_APP, enabled: true, size: 1000 }));
  },
  getPopupsByUser(clientId) {
    return ApiFetchInstance.get(preparePath(URLS.popupsByUser, { clientId }, { type: CMS_POPUP_TYPE.IN_APP, enabled: true }));
  },
  getDocument(hash) {
    return ApiFetchInstance.get(`${URLS.documents}/${hash}`);
  },
};
